import { createUseStyles } from 'react-jss';
import {
  cssColorPrimary,
  cssColorSecondary,
  cssFontSizeLarge,
  cssSpacingLg,
  cssSpacingSm,
} from '../../constants/globalcss';

export const useStyles = createUseStyles({
  button: {
    marginBlockEnd: cssSpacingSm,
  },
  content: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 100px)',
    padding: cssSpacingLg,
  },
  error: {
    color: cssColorPrimary,
    margin: cssSpacingSm,
    textAlign: 'center',
  },
  errorCenter: {
    alignItems: 'center',
    color: 'red',
    display: 'flex',
    fontSize: 20,
    fontWeight: 600,
    justifyContent: 'center',
    minHeight: '40vh',
  },
  header: {
    color: cssColorSecondary,
    fontSize: cssFontSizeLarge,
    fontWeight: 500,
    marginBottom: '1.5rem',
  },
  headerControls: {
    alignItems: 'center',
    display: 'flex',
  },
  homeMenu: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    '&:hover': {
      backgroundColor: '#f3f3f3',
    },
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'right',
    paddingBlock: cssSpacingSm,
  },
  menuButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    padding: cssSpacingLg,
  },
  sectionTitle: {
    flexGrow: 0,
    minWidth: 0,
    textAlign: 'left',
  },
  toggleMargin: {
    marginRight: 16,
  },
});
